import axios from "axios";

// TODO - REMOVE THE STORE REFERENCE; MOVE API_URL TO ENVIRONMENT VARIABLE
import { useAppSetupStore } from "@/store/appSetup";
import { useAuthenticationStore } from "@/store/authentication";

const appSetupStore = () => useAppSetupStore();
const authenticationStore = () => useAuthenticationStore();

export default {
  async all() {
    let data = null;
    if (authenticationStore().isSignedIn) {
      let token = await authenticationStore().returnIdToken();
      let response = await axios.get(appSetupStore().apiUrl + "user/catalog", {
        headers: {
          Authorization: token,
        },
      });
      data = response.data;
    } else {
      let response = await axios.get(appSetupStore().apiUrl + "datasets");
      data = response.data;
    }

    data.sort(function (a, b) {
      return a.udpName > b.udpName ? 1 : b.udpName > a.udpName ? -1 : 0;
    });
    return data;
  },
  async byIdUnauthenticated(id) {
    return await axios.get(appSetupStore().apiUrl + `datasets/${id}`);
  },
  async byIdAuthenticated(id, token) {
    return await axios.get(appSetupStore().apiUrl + `user/catalog/${id}`, {
      headers: {
        Authorization: token,
      },
    });
  },
  byId(id) {
    return axios.get(appSetupStore().apiUrl + "datasets/" + id + "/vrde");
  },
  async getAdminList(updateType) {
    let token = await authenticationStore().returnIdToken();
    return axios.get(
      appSetupStore().apiUrl + "admin/datasets/updates/" + updateType,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  },
};
